import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { GET_USER_QUERY } from 'src/modules/graphql/getUser.graphql';
import type { GetUserInfoQuery } from 'src/types/graphql';

import { AUTHENTICATION_TYPES } from '../types/Authentication';

export function useUserProfile() {
  const { data } = useQuery<GetUserInfoQuery>(GET_USER_QUERY);
  const user = useMemo(() => data?.viewer, [data]);

  // update authenticationStatus when user obj has been updated
  const authenticationStatus = useMemo(
    () =>
      user
        ? AUTHENTICATION_TYPES.AUTHENTICATED
        : AUTHENTICATION_TYPES.UNAUTHENTICATED,
    [user],
  );

  return { user, authenticationStatus };
}
